<template>

<div>
  <el-alert v-if="warningMessage" type="warning" title="Warning" show-icon :description="warningMessage" :closable="false" />

  <h4 v-if="title && !warningMessage">{{title}}</h4>&nbsp;
  <table class="el-table" v-if="site && !warningMessage">
    <thead>
      <tr>
        <th>#</th>
        <th>Sharer</th>
        <th><span>Sharing %</span></th>
        <th v-if="tax"><span>Amount</span></th>
        <th v-if="tax"><span>{{taxLabel}}</span></th>
        <th><span>TOTAL</span></th>
        <th><span>Advance</span></th>
        <th><span>Adjustment</span></th>
      </tr>
    </thead>

    <tfoot>
      <tr>
        <td></td>
        <td></td>
        <td align="right"><b>{{formatNumber(sharingTotal, 1)}}%</b></td>
        <td v-if="tax" align="right"><b>{{formatNumber(subTotal)}}</b></td>
        <td v-if="tax" align="right"><b>{{formatNumber(taxTotal)}}</b></td>
        <td align="right"><b>{{formatNumber(total)}}</b></td>
        <td align="right"><b>{{formatNumber(totalAdv)}}</b></td>
        <td align="right"><b>{{formatNumber(totalAdj)}}</b></td>
      </tr>
    </tfoot>

    <tbody>
      <tr v-for="(telco, index) in site.sharers" :key="telco.id">
        <th>{{index+1}}</th>
        <td>{{telco.organisation.shortName}} <small class="text-muted hidden-md-and-down">{{telco.telcoSiteId}}</small> <span v-if="telco.ownMeter"><b class="text-primary"><i class="fa fa-plug"></i></b></span><span v-if="telco.cabin"><b class="text-info"><i class="fa fa-home"></i></b></span></td>

        <td v-if="!telco.ownMeter" align="right" class="text-warning">{{formatNumber(sharingPercent(index), 1)}}%</td>
        <td v-else></td>

        <td v-if="tax && !telco.ownMeter" align="right">{{formatNumber(sharingValue(index))}}</td>
        <td v-else></td>

        <td v-if="tax && !telco.ownMeter" align="right">{{formatNumber(taxValue(index))}}</td>
        <td v-else></td>

        <td v-if="!telco.ownMeter" align="right"><b>{{formatNumber(totalValue(index))}}</b></td>
        <td v-else></td>

        <td v-if="!telco.ownMeter" align="right" class="text-primary">{{formatNumber(advanceValue(index))}}</td>
        <td v-else></td>

        <td v-if="!telco.ownMeter" align="right"><span :class="adjustmentValue(index) < 0 ? 'text-danger' : 'text-success'">{{formatNumber(adjustmentValue(index))}}</span></td>
        <td v-else></td>
      </tr>
    </tbody>
  </table>

</div>

</template>

<script>

import {settings} from '@/components/Data'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import PostMixins from '@/mixins/PostMixins'

export default {
  mixins: [DateMixins, NumberMixins, PostMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },

    siteId: {
      type: Number,
      default: null
    },

    title: {
      type: String,
      default: null
    },

    tax: {
      type: Boolean,
      default: true
    }

  },

  methods: {
    requestSite () {

      if (this.site_id) {
        var url = '/site/' + this.site_id
        this.fetchData(url, this.setSite, 'Site Details')
      }

    },

    setSite (siteDetails) {
      this.site = siteDetails

      if (this.site.sharers.length > 0) {
        this.requestRates()
      }

    },

    requestRates () {
      var url = '/rates/utility/' + this.totalUsers + '/cabins/' + this.totalCabins

      this.fetchData(url, this.setRates, 'Utility Rates')
    },

    setRates (rateTable) {

      if (rateTable.warning) {
        this.warningMessage = rateTable.warning
        this.rates = null
        return
      }

      this.rates = rateTable

      // Fallback if rates are empty.
      if (this.rates.length === 0) {

        console.log('Rates are zero- creating default rates')

        let sh = 100 / this.totalUsers
        let arr = {}

        for (let i = 1; i <= this.totalUsers; i++) {
          arr['telco' + i] = sh
        } // for

        this.rates.push(arr)
      }

      this.refreshTable()
    },

    sharingPercent (index) {
      return this.sharing[index] ? this.sharing[index].percent : null
    },

    sharingValue (index) {
      return this.sharing[index] ? this.sharing[index].value : null
    },

    taxValue (index, telco) {

      if (this.tax) {
        return this.sharing[index] ? this.sharing[index].tax : null
      } else {
        return 0
      }

    },

    advanceValue (index, telco) {
      return this.sharing[index] ? this.sharing[index].advance : null

    },

    totalValue (index) {
      return this.sharing[index] ? this.sharing[index].total : null
    },

    adjustmentValue (index) {
      return Number(this.totalValue(index) - this.advanceValue(index))
    },

    refreshTable () {

      this.sharing = []

      let rate = 100 / this.totalUsers // default rate
      let rateId = 1

      for (let i = 0; i < this.site.sharers.length; i++) {
        let sh = {}

        sh['sharer'] = this.site.sharers[i].organisation.shortName
        sh['sharerId'] = this.site.sharers[i].telcoSiteId

        if (this.site.sharers[i].ownMeter) {

          sh['rateId'] = null
          sh['percent'] = null
          sh['value'] = null
          sh['tax'] = null
          sh['advance'] = null
          sh['total'] = null

        } else {

          sh['rateId'] = rateId
          sh['percent'] = this.rates.length > 0 ? this.rates[0]['telco' + rateId] : rate
          sh['value'] = Number((this.billData.total - this.billData.tax) * (sh['percent'] / 100))

          if (this.tax) {
            sh['tax'] = Number(this.billData.tax * (sh['percent'] / 100))
          } else {
            sh['tax'] = 0
          }

          sh['advance'] = this.site.sharers[i] && this.site.sharers[i].utilityStandardRate
          ? Number(this.site.sharers[i].utilityStandardRate)
          : 0.00
          sh['total'] = Number(this.billData.total * (sh['percent'] / 100))
          rateId += 1
        }

        this.sharing.push(sh)
      }

    },

    refresh () {
      this.refreshTable()
    },

    sumCol (col) {
      let res = 0

      for (let i = 0; i < this.sharing.length; i++) {
        res += Number(this.sharing[i][col])
      }

      return res
    }

  },

  computed: {
    sharingTotal: function () {
      return this.sumCol('percent')
    },

    subTotal: function () {
      return this.sumCol('value')
    },

    taxTotal: function () {
      return this.sumCol('tax')
    },

    total: function () {
      return this.sumCol('total')
    },

    totalAdv: function () {
      return this.sumCol('advance')
    },

    totalAdj: function () {
      return this.formatNumber(this.total - this.totalAdv)
    },

    totalUsers () {
      var users = 0
      if (this.site.sharers && this.site.sharers.length > 0) {
        for (var i = 0; i < this.site.sharers.length; i++) {
          if (!this.site.sharers[i].ownMeter) {
            users++
          }
        }
      }
      return users
    },

    totalCabins () {
      var cabins = 0

      if (this.totalUsers > 1) {
        for (var i = 0; i < this.totalUsers; i++) {
          if (this.site.sharers[i].cabin && this.site.sharers[i].cabin === true && !this.site.sharers[i].ownMeter) {
            cabins++
          }
        }  // for
      }

      return cabins
    }

  },

  data () {
    return {
      warningMessage: null,
      billData: this.rowData,
      utilLabel: this.getUtilLabel(this.rowData),
      taxLabel: settings.taxName,
      site: null,
      rates: [],
      sharing: [],
      site_id: this.siteId ? this.siteId : this.rowData && this.rowData.site_id ? this.rowData.site_id : null
    }
  },

  mounted () {
    this.requestSite()
  }

}

</script>
